import React from 'react';

// styles
import { SlideWrapper, Title, SlidePanel, Content } from './Slide.styles';

export function Slide({ property }) {
  return (
    <SlideWrapper>
      <SlidePanel>
        <Title>{property.title}</Title>
        <Content>{property.content}</Content>
      </SlidePanel>
    </SlideWrapper>
  );
}
